import { useState, useEffect } from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import { useAuth } from "../../components/Auth";
import {
    FullScreeningModal,
    FullScreeningReportCard,
    fullScreeningModalTabs,
    useLoader
} from "stm-frontend-library";
import { useFullScreening } from "./hooks/useFullScreening";
import { showSuccessToast, showErrorToast } from "../../helpers/helpers";

const FullScreening = () => {
    const { profile } = useAuth();
    const { showLoader, hideLoader } = useLoader();
    const {
        data,
        isLoading,
        isDeleting,
        error,
        loadReports,
        deleteReport
    } = useFullScreening();

    const [isArticleModalOpen, setIsArticleModalOpen] = useState(false);
    const [tabId, setTabId] = useState(fullScreeningModalTabs.externalTools);
    const [datalistIndex, setDatalistIndex] = useState(null);

    useEffect(() => {
        if (isLoading || isDeleting) {
            showLoader();
        } else {
            hideLoader();
        }
    }, [isLoading, isDeleting]);

    const modalContent = data[datalistIndex] ?? {};

    const showInfo = (index, tab) => {
        setTabId(tab);
        setDatalistIndex(index);
        setIsArticleModalOpen(true);
    };

    const handleDeleteEvent = async () => {
        if (datalistIndex !== null && data[datalistIndex]?.id) {
            const deletedId = data[datalistIndex].id;
            const result = await deleteReport(deletedId);

            if (result.success) {
                showSuccessToast("Removed successfully");
                setIsArticleModalOpen(false);
                setDatalistIndex(null);
            } else {
                showErrorToast("Failed to delete report");
            }
        }
    };

    return (
        <MDBContainer className="my-5">
            <FullScreeningModal
                isOpen={isArticleModalOpen}
                setIsOpen={setIsArticleModalOpen}
                tab={tabId}
                data={modalContent}
                onLoadReport={loadReports}
                onDeleteEvent={handleDeleteEvent}
                eventDeleting={isDeleting}
                profile={profile}
            />
            {data.length > 0 ? (
                data.map((item, index) => (
                    <FullScreeningReportCard
                        key={item.id}
                        item={item}
                        index={index}
                        showInfo={showInfo}
                        profile={profile}
                    />
                ))
            ) : (
                !isLoading && (
                    <div className="text-center text-muted">
                        No screening reports found
                    </div>
                )
            )}
        </MDBContainer>
    );
};

export default FullScreening;
